var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"c-main-nav-cart",on:{"click":_vm.toggleCart}},[_c('img',{staticClass:"c-main-nav-cart__icon",attrs:{"src":require("assets/icons/cart-icon.svg"),"alt":"cart"}}),_vm._v(" "),(_vm.quantityTotal > 0)?_c('span',{staticClass:"c-main-nav-cart__count",class:{
      'c-main-nav-cart__count--double-digits': _vm.quantityTotal > 10
    }},[_vm._v("\n    "+_vm._s(_vm.quantityTotal)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }